import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { AddDropReasonComponent } from './addDropReason.component';
import { CommonService, ServiceWalkInService, SubscribeService, EditService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
import { clientHistoryComponent } from '../../common/clientHistory';
import { serviceReplyComponent } from './serviceReply.component';
import { AddServiceTestingComponent } from '../testingTrail/addServiceTesting.component';

@Component({
    selector: 'service-walk-in-tab',
    templateUrl: './serviceWalkIn.component.html'
})
export class ServiceWalkInComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input('params') params: string;
    subscription: Subscription;
    isLoadMask: Promise<any>;
    serviceWalkInData: ServiceWalkInModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cst.date',
        orderDir: 'DESC'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('printPage') printPage;
    @ViewChild('changeBranchModal') changeBranchModalTemp: TemplateRef<any>;
    @ViewChild('printAcknowTemplate') printAcknowTemplate:TemplateRef<any>;
    @ViewChild('printBillTemplate') printBillTemplate:TemplateRef<any>;
    @ViewChild('changeEmployeeModal') changeEmployeeModalTemp: TemplateRef<any>;
    statusCusCtrl: FormControl;
    phstatusCusCtrl: FormControl;
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    statusList: any[];
    phoneProcessList: any[];
    columns = [];
    branchList: any[] = [];
    // initialCoumns = [];
    // phoneTrackColumns = [];
    toggleCol = [];
    filterData = {
        view_type: "",
        curr_view_type: "",
        warranty: "All",
        from_date: new Date(),
        to_date: new Date()
    };
    print_sts = {
        print_type:""
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    printConfig: any;
    isLoading: boolean;
    changeBranchDet: {
        ser_id: number,
        branch_id: number,
        to_branch: number,
        to_branch_name: string,
        courier_no: number,
        courier_name: string
    };
    changeEmployeeDet: {
        ser_id: number,
        employee_id: number
    };
    isAdmin: boolean;
    curBranch: any;
    userType: any;
    warrantyList: any = ['Within Warranty', 'Out of Warranty', 'All'];
    branch:any;
    hvUserCtrl: FormControl;
    hvUserList: any[] = [];
    filteredHvuserlist: Observable<any[]>;

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService, private servicewalkInService: ServiceWalkInService,
        public subscribeService: SubscribeService, private modalService: BsModalService, private editService: EditService, private commonService: CommonService) {
        this.statusCusCtrl = new FormControl();
        this.phstatusCusCtrl = new FormControl();
        this.statusList = ['Bill', 'Phone Tracking', 'Import', 'Export', 'Return', 'Print', 'Reply', 'Closed by Head Office'];
        this.isAdmin = false;
        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());
        
        this.hvUserCtrl = new FormControl();
        this.filteredHvuserlist = this.hvUserCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHvUser(name) : this.hvUserList.slice());
    }

    ngOnInit(): void {
        let that = this;
        this.createColumnDef();
        this.getHVUserList();
        this.pageCallback({ offset: 0 });

        // this.subscription = this.subscribeService.publishReloadClientWalkInGrid().subscribe(($e) => {
        //     that.pageCallback({ offset: 0 });
        // });
        this.subscription = this.subscribeService.publishReloadServiceGrid().subscribe(($e) => {
                that.pageCallback({ offset: 0 });
            });
        // );

        //TO LOAD BRANCH COMBO
        this.subscription.add(this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        }));

        this.subscription.add(this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                if (auth['usertype'] == 'Super_Admin' || auth['usertype'] == 'Admin') {
                    this.isAdmin = true;
                }
                this.curBranch = auth['branch_id'];
                this.userType = auth['usertype'];
            }
        }));
        if(this.curBranch == 8 || this.userType == 'Super_Admin'){
            this.phoneProcessList = ['Confirmation Call','Estimation From Company', 'Estimation From HeadOffice', 'Estimation To Client', 'Approval From Client', 'Approval To Company', 'Approval To HeadOffice', 'Informed Delivery To Client'];
        } else {
            this.phoneProcessList = ['Estimation From Company', 'Estimation From HeadOffice', 'Estimation To Client', 'Approval From Client', 'Approval To Company', 'Approval To HeadOffice', 'Informed Delivery To Client'];
        }
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    }

    createColumnDef() {
        const initialCoumns = [
            { name: 'SRF No', prop: 'srf_no', width: 80, minWidth: 80, maxWidth: 80, toggle: false },
            { name: 'Booking Date', prop: 'service_walkin_date', width: 130, minWidth: 130, maxWidth: 130, toggle: false },
            { name: 'From Branch', prop: 'booking_branch', width: 120, minWidth: 120, maxWidth: 120, toggle: false },
            { name: 'Client Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Client No.', prop: 'mobile', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Machine Name', prop: 'mode_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Employee Name', prop: 'emp_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Action', prop: 'action', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate },
        ];
        const printColumns = [
            { name: 'Bill Print', prop:'action', width:140, minWidth: 140, maxWidth: 140,sortable: false, cellClass:'cell-center',cellTemplate: this.printBillTemplate },
            { name: 'Acknowledgement Print', prop: 'action', width: 200, minWidth: 200, maxWidth: 200, sortable: false, cellClass: 'cell-center', cellTemplate: this.printAcknowTemplate },
        ];
        const phoneTrackColumns = [
            { name: 'Pre. Status Date', prop: 'conv_pre_status_date', width: 135,minWidth: 135, maxWidth: 135, toggle: false },
            { name: 'Last Date', prop: 'date', width: 120,minWidth: 120, maxWidth: 120, toggle: false },
            { name: 'Next Followup Date', prop: 'nxt_fol_date', width: 180,minWidth: 180, maxWidth: 180, toggle: false },
            { name: 'Last Description', prop: 'description', width: 180,minWidth: 180, maxWidth: 180 },
        ];

        if(this.filterData.view_type === 'Phone Tracking') {
            this.columns = initialCoumns.concat(phoneTrackColumns);
        } else if(this.filterData.view_type === 'Reply') {
            // TO REMOVE UN WANTED COUMNS
            initialCoumns.splice(5, 1);
            initialCoumns.splice(1, 1);
            this.columns = initialCoumns;
            this.columns.splice(this.columns.length -1, 0, phoneTrackColumns[2])
        } else if (this.filterData.view_type === 'Print'){
            initialCoumns.splice(6,1);
            this.columns = initialCoumns.concat(printColumns);
        } else {
            this.columns = initialCoumns;
        }
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    getHVUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        that.commonService
            .getHVUserList(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.hvUserList = res.data;
                }
            });
    }

    // HV User display
    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }

    assignFn(empid: any) {
        if (this.hvUserList != undefined) {
            if (empid && this.hvUserList.length > 0) {
                if (typeof empid == 'string') {
                    empid = parseInt(empid);
                }
                let fitem = _.find(this.hvUserList, { 'userid': empid });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';
    }

    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterTextBox').focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getServiceWalkInList();
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getServiceWalkInList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 1000)
    }
    clearFilter(): void {
        this.filterData = {
            view_type: "",
            curr_view_type: "",
            warranty: "All",
            from_date: new Date(),
            to_date: new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getServiceWalkInList();
    }
    getServiceWalkInList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            //filter: JSON.stringify(this.filterData),
            view_type: this.filterData['view_type'],
            phone_process: this.filterData['phone_process'],
            from_page: this['params']['tabParams'],
            srf_no: this.filterData['srf_no'],
            branch_id: this.filterData['branch_id']
        };
        if (this.filterData['nextFollowUp'] && (this.filterData['view_type'] =='Phone Tracking' || this.filterData['view_type'] =='Reply')) {
            if (_.isDate(this.filterData['from_date'])) {
                params['from_date'] = moment(this.filterData['from_date']).format('YYYY-MM-DD');
            }
            if (_.isDate(this.filterData['to_date'])) {
                params['to_date'] = moment(this.filterData['to_date']).format('YYYY-MM-DD');
            }
        }
        if (this.filterData['view_type'] !='Reply' && this.filterData['warranty'] != 'All') {
            params['warranty'] = this.filterData['warranty'];
        }
        if(this.filterData['warranty'] =='Within Warranty')
        {
            params['warranty']='Yes';
        }
        if(this.filterData['warranty'] =='Out of Warranty')
        {
            params['warranty']='No';
        }
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.servicewalkInService
            .getServiceWalkInList(params)
            .then(function (res: any) {
                that.filterData.curr_view_type = that.filterData['view_type'];
                // if(that.filterData.view_type === 'Phone Tracking') {
                //     that.columns = that.initialCoumns.concat(that.phoneTrackColumns);
                // } else {
                //     that.columns = that.initialCoumns;
                // }
                that.createColumnDef();
                that.loadingIndicator = false;
                if (res && res.totCnt && res.data && res.data.length) {
                    that.page.count = res.totCnt;
                    that.serviceWalkInData = res.data;
                } else {
                    that.page.count = 0;
                    that.serviceWalkInData = [];
                }        
            });
    }

    public addReturn(mode: string, row: any): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddImportExportComponent', Object.assign({}, row), 'Return');
    }

    public addImport(mode: string, row: any): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddImportExportComponent', Object.assign({}, row), 'Import');
    }

    public addPhone(mode: string, row: any): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'ServicePhoneTrackingComponent', Object.assign({}, row), 'Phone Tracking');
    }

    public addCall(btnType: string, row: any): void {

        let that = this,
        pageType = this.params['tabParams'];
        row['page_from'] = pageType;
        
            this.bsModalRef = this.modalService.show(AddServiceTestingComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-70'
            });
            row['view_type']="Analyse";
            row['btnType']=btnType;
            row['branch']=this.branch;
            this.bsModalRef.content.testingdata = Object.assign({}, row);
        

        this.bsModalRef.content.title = pageType + ' Details';
        this.bsModalRef.content.testingTrailLoadEvent.subscribe(($e) => {
            that.getServiceWalkInList();
        });
    }

    public addExport(mode: string, row: any): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddImportExportComponent', Object.assign({}, row), 'Export');
    }

    public addBill(mode: string, row: any): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddBillEntryComponent', Object.assign({}, row), 'billEntry');
    }

    addEditServiceWalkIn(mode: string, row: any): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'ser_id': '',
                mode: mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddServiceWalkInComponent', Object.assign({}, row), this['params']['tabParams']);

    }


    bsModalRef: BsModalRef;
    public deleteServiceWalkIn(row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddDropReasonComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        // row['mode'] = mode;

        this.bsModalRef.content.dropdata = Object.assign({}, row);
        this.bsModalRef.content.branchLoadEvent.subscribe(($e) => {
            that.getServiceWalkInList();
        });

    }

    /*deleteServiceWalkIn(row: any): void {

        let that = this,
            data = {
                ser_id: row.ser_id,
            };
        swal({
            title: 'Are you sure to Drop?',
            text: 'You will not be able to Recover this Walk-In Details of [' + row['client_no'] + '-' + row['client_name'] + ']',
            showCancelButton: true,
            confirmButtonText: 'Yes, Drop!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.servicewalkInService
                .deleteServiceWalkIn(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getServiceWalkInList();
                        swal(
                            'Dropped',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }*/

    onPrintReport(row: any) {
        let that = this;
        this.printConfig = {
            type: this.title,
            title: 'SOUNDS GOOD HEARING CARE',
            subTitle: 'Service Bill',
            rows: row,
            columns: that.columns
        }
        setTimeout(() => {
            that.printPage.printPreview();
        }, 100);
    }

    async onPrintAcknowledgementReport(row: any) {
        let that = this;
        const modelDet = await this.getHaModelDetails(row);
        row['modelDet'] = modelDet;
        this.printConfig = {
            type: 'Service Ackowledment',
            title: 'SOUNDS GOOD HEARING CARE',
            subTitle: 'Service Ackowledment',
            rows: row,
            columns: that.columns
        }
        setTimeout(() => {
            that.printPage.printPreview();
        }, 100);
    }

    async getHaModelDetails(data: any) {
        let that = this,
            params = {
                sale_bill_id: data.sale_bill_id,
                ser_id: data.ser_id,
                mode: data.mode
            };
        let response: any = [];
        await this.servicewalkInService
            .getServiceModelDetails(params)
            .then(function (res: any) {
                // that.page.count = res.totCnt;
                // that.salesBillentryDetails = res.data;
                response = res.prodRes;
            });
        return await response;
    }

    /**
    * TO CHANGE SPECIFIC ROW COLOR
    */
    getRowClass(row) {
        if (row.today_entry) {
            return {
                'service-tracking-today': true
            };
        } else if (row.yesterday_entry) {
            return {
                'service-tracking-yesterday': true
            };
        }
    }

    viewHistory(row) {
        const data = {
            client_id: row.client_id,
            from_page: 'followUp'
        };
        this.bsModalRef = this.modalService.show(clientHistoryComponent,{
            keyboard: false,
            class: 'modal-lg maxWidthPer-80 clienthistorywidth'
        });
        this.bsModalRef.content.showClientHistory = data;
    }

    onClickReply(row) {
        const data = {
            client_id: row.client_id,
            walkin_id: row.walkin_id,
            client_name: row.client_name
        };
        this.bsModalRef = this.modalService.show(serviceReplyComponent,{
            keyboard: false,
            class: 'modal-md'
        });
        this.bsModalRef.content.rowDetails = data;
        this.bsModalRef.content.servicReplyEvent.subscribe(($e) => {
            this.pageCallback({ offset: 0 });
        });
    }

    changeEmployee(row){
        // this.changeEmployeeDet = row;
        // this.bsModalRef = this.modalService.show(this.changeEmployeeModalTemp,{
        //     keyboard: false,
        //     class: 'modal-md'
        // });

        this.bsModalRef = this.modalService.show(serviceReplyComponent,{
            keyboard: false,
            class: 'modal-md'
        });
        row['view_type'] = 'HV Delivery';
        this.bsModalRef.content.rowDetails = row;
        this.bsModalRef.content.servicReplyEvent.subscribe(($e) => {
            this.pageCallback({ offset: 0 });  
        });
    }

    changeBranch(row) {
        this.changeBranchDet = row;
        this.bsModalRef = this.modalService.show(this.changeBranchModalTemp,{
            keyboard: false,
            class: 'modal-md'
        });
    }

    onSaveChangBranch(changeBranchID,courier_no,courier_name) {
        const branchObj = _.find(this.branchList, { 'branch_id': changeBranchID });
        if(branchObj){
            const changeBranchName = branchObj['branch_name'];

            if(this.changeBranchDet.branch_id == changeBranchID) {
                this.toasterService.pop({
                    type: 'warning',
                    title: 'WARNING',
                    body: "Same Branch can't be Changed"
                });
            } else {
                this.isLoading = true;
                this.editService
                    .modifyTransactionDetails({
                        transaction_type: "ServiceWalkin_ChangeBranch",
                        ser_id: this.changeBranchDet.ser_id,
                        change_branch_id: changeBranchID,
                        pre_to_branch_id: this.changeBranchDet.to_branch,
                        pre_to_branch_name: this.changeBranchDet.to_branch_name,
                        change_branch_name: changeBranchName,
                        courier_no: courier_no,
                        courier_name: courier_name
                    })
                    .then((res: any) => {
                        this.isLoading = false;
                        if (res.success) {
                            this.changeBranchDet = {
                                ser_id: null,
                                branch_id: null,
                                to_branch: null,
                                to_branch_name: null,
                                courier_no: null,
                                courier_name: null
                            };
                            this.getServiceWalkInList();
                            this.bsModalRef.hide();
                            this.toasterService.pop({
                                type: 'success',
                                title: 'SUCCESS',
                                body: res.message
                            });
                        } else {
                            this.toasterService.pop({
                                type: 'warning',
                                title: 'WARNING',
                                body: res.message
                            });
                        }
                    });
                this.bsModalRef.hide();
            }
        } else {
            this.toasterService.pop({
                type: 'error',
                title: 'Error',
                body: "Please Select Valid Branch"
            });
        }
        
    }

    closeSrf(row){
        let that = this;
        swal({
            title: 'Are you sure to close this SRF?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'Yes, Close it!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            let params = {
                serviceDetails : JSON.stringify(row)
            }
            that.isLoadMask = that.editService
                .closeSrf(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;

                    if (res.success) {
                        that.getServiceWalkInList();
                        swal('SUCCESS', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                }).catch(function(error: any) {
                    that.isLoading = false;
                    let res = JSON.parse(error._body);
                    swal('ERROR', res.message, 'error');
                    //console.log(error);
                });

        }, function(dismiss) {

        })
    }

    reopenSrf(row){
        let that = this;
        swal({
            title: 'Are you sure to Reopen this SRF?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'Yes, Close it!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            let params = {
                serviceDetails : JSON.stringify(row)
            }
            that.isLoadMask = that.editService
                .reopenSrf(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;

                    if (res.success) {
                        that.getServiceWalkInList();
                        swal('SUCCESS', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                }).catch(function(error: any) {
                    that.isLoading = false;
                    let res = JSON.parse(error._body);
                    swal('ERROR', res.message, 'error');
                    //console.log(error);
                });

        }, function(dismiss) {

        })
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/serviceWalkIn.component.ts